import stateMapping from "../../stateMapping";
import {DEGREE_LIST, CATEGORY_LIST, CATEGORY_DEGREE_LIST} from "../../data";

export const capitalizeFirstLetter = (str) => {
  let words = str?.split(" ");
  for (let i = 0; i < words?.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  let capitalizedStr = words?.join(" ");
  return capitalizedStr;
};

export const getStateFromCode = (state) => {
  if (!state) return "";
  let statefound = stateMapping.find((s) => s.stateCode.toLowerCase() === state.toLowerCase());
  return statefound?.state || "";
};

export const getStateCode = (state) => {
  if (!state) return "";
  let statefound = stateMapping.find((s) => s.state.toLowerCase() === state.toLowerCase());
  return statefound?.stateCode || "";
};

export const trackGtmPixel = (eventName, eventObj = {}) => {
  if (!eventName) {
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventObj,
  });
  if (process.env.NODE_ENV === "development") {
    console.log("GTM:", eventName, eventObj);
  }
};

export function getCategoryList() {
  let modifiedCategory = [];
  CATEGORY_LIST.forEach((category) => {
    if (category?.isActive) {
      modifiedCategory.push(category);
    }
  });
  return modifiedCategory;
}

export function getDegreeList(category) {
  let modifiedDegree = [];
  DEGREE_LIST.forEach((degree) => {
    if (degree?.isActive && CATEGORY_DEGREE_LIST[category].includes(degree?.id)) {
      modifiedDegree.push(degree);
    }
  });
  modifiedDegree.sort((a, b) => a.order - b.order);
  return modifiedDegree;
}

export function getDegreeValue(degreeUrl) {
  if (degreeUrl === "") {
    degreeUrl = "all";
  }
  return DEGREE_LIST.find((degree) => degree.path === degreeUrl)?.value;
}

export function getCategoryValue(categoryUrl) {
  if (categoryUrl === "") {
    categoryUrl = "all";
  }
  return CATEGORY_LIST.find((category) => category.path === categoryUrl)?.value;
}

const getHardCodeOffers = () => {

  const harcodedOffers = [
    {
      "college_id": "post-university1",
      "college_name": "Post University",
      "is_active": true,
      "college_description": "Supporting students with personal attention and flexible programs for more than 130 years\r\n-Led by professional practitioners who bring years of practical experience\r\n\r\n-One-on-one attention from experienced faculty and staff\r\n\r\n-Several flexible undergraduate and graduate-level programs on offer",
      "logo_url": "https://collegenroll-static.s3.us-west-1.amazonaws.com/public_media/post.png",
      "offer_level": "COLLEGE_LEVEL",
      "provider_id": "adnet-linkout",
      "location": {
          "city": "",
          "state": "",
          "zip_code": "",
          "distance": ""
      },
      "degrees": [
          "Bachelor",
          "Master",
          "Doctorate / Specialist"
      ],
      "headline": "Learn from industry experts in highly interactive courses",
      "click_url": "https://leads-inst494-client.phonexa.com/lynx/click?offer_id=35&aff_id=1",
      "start_date": null,
      "campus_name": "Online Program",
      "campus_type": "Online",
      "program_flow": {
          "headline": "Supporting students with personal attention and flexible programs for more than 130 years",
          "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
          "college_description": "<li>Led by professional practitioners who bring years of practical experience</li><li>One-on-one attention from experienced faculty and staff</li><li>Several flexible undergraduate and graduate-level programs on offer</li>",
          "additional_information": null
      },
      "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
      "university_redirect_url": "https://leads-inst494-client.phonexa.com/lynx/click?offer_id=35&aff_id=1",
      "program_flow_description": "<li>Led by professional practitioners who bring years of practical experience</li><li>One-on-one attention from experienced faculty and staff</li><li>Several flexible undergraduate and graduate-level programs on offer</li>",
      "programs": [],
      "ce_offer_id": "29011658-eed9-4310-8c57-7edab8791f7b",
      "revenue": 0,
      "program_name": "GRADUATE CERTIFICATE IN MARKETING",
      "category": "business-management"
      
    },
    {
      "college_id": "keiser-university1",
      "college_name": "Keiser University",
      "is_active": true,
      "college_description": "Supporting students with personal attention and flexible programs for more than 130 years\r\n-Led by professional practitioners who bring years of practical experience\r\n\r\n-One-on-one attention from experienced faculty and staff\r\n\r\n-Several flexible undergraduate and graduate-level programs on offer",
      "logo_url": "https://collegenroll-static.s3.us-west-1.amazonaws.com/public_media/post.png",
      "offer_level": "COLLEGE_LEVEL",
      "provider_id": "adnet-linkout",
      "location": {
          "city": "",
          "state": "",
          "zip_code": "",
          "distance": ""
      },
      "degrees": [
          "Bachelor",
          "Master",
          "Doctorate / Specialist"
      ],
      "headline": "Take the Next Step Towards Your Future At Keiser University",
      "click_url": "https://keiser.collegenroll.com/search/3/?q=business_degree_ce_2",
      "start_date": "Upcoming Class on 25th Aug 2024!",
      "campus_name": "Online Program",
      "campus_type": "Campus",
      "program_flow": {
          "headline": "Supporting students with personal attention and flexible programs for more than 130 years",
          "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
          "college_description": "<li>Led by professional practitioners who bring years of practical experience</li><li>One-on-one attention from experienced faculty and staff</li><li>Several flexible undergraduate and graduate-level programs on offer</li>",
          "additional_information": null
      },
      "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
      "university_redirect_url": "https://collegenroll.com/schools/keiser-university/",
      "program_flow_description": "<li>Choose from over 100+ Undergraduate & Graduate Programs</li><li>20+ Campuses across Florida</li><li>Smaller Class Sizes for Personalized Learning</li><li>Generous Scholarship Opportunities (for eligible students)</li>",
      "programs": [],
      "ce_offer_id": "29011658-eed9-4310-8c57-7edab8791f7b",
      "revenue": 0,
      "program_name": "GRADUATE CERTIFICATE IN MARKETING",
      "category": "business-management"
    },
    {
      "college_id": "liberty-university",
      "college_name": "Liberty University",
      "is_active": true,
      "college_description": "Liberty University emphasizes balancing academic theory, research, and hands-on training, giving you the tools to do your job ethically and to the best of your abilities. With 8 start dates per year, convenient 8-week courses with no set login* times, and flexible options for furthering your education",
      "logo_url": "https://collegenroll.com/wp-content/themes/collegenroll/assets/dedicated-lander/liberty/v1/images/liberty-logo.png",
      "offer_level": "COLLEGE_LEVEL",
      "provider_id": "collegenroll",
      "location": {
          "city": "",
          "state": "",
          "zip_code": "",
          "distance": ""
      },
      "degrees": [
          "Bachelor",
          "Master",
          "Doctorate / Specialist"
      ],
      "headline": "Earn An Online Degree From The Comfort Of Your Home",
      "click_url": "https://leads-inst494-client.phonexa.com/lynx/click?offer_id=6&aff_id=1",
      "start_date": "Upcoming class on 12th May 2025",
      "campus_name": "Online Program",
      "campus_type": "Online",
      "program_flow": {
          "headline": "Supporting students with personal attention and flexible programs for more than 130 years",
          "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
          "college_description": "<li>Flexible program options from a Christian worldview</li><li>Convenient 8-week courses with no set log-in times (some exclusions apply)</li><li>No increase in tuition rates in 9 years</li>",
          "additional_information": null
      },
      "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
      "university_redirect_url": "https://collegenroll.com/schools/liberty-university/",
      "program_flow_description": "<li>Flexible program options from a Christian worldview</li><li>Convenient 8-week courses with no set log-in times (some exclusions apply)</li><li>No increase in tuition rates in 9 years</li>",
      "programs": [],
      "ce_offer_id": "29011658-eed9-4310-8c57-7edab8791f7d",
      "revenue": 0,
      "program_name": "GRADUATE CERTIFICATE IN MARKETING",
      "category": "all"
    },
    {
      "college_id": "snhu1",
      "college_name": "SNHU",
      "is_active": true,
      "college_description": "Committed to providing accessible higher education for all\r\n200 career-focused programs with no set class times so you can learn online, on your schedule.\r\nDiverse student body with more than 3,000 on campus students & over 170,000 online students\r\nFlexible transfer policy, letting you transfer up to 90 credits towards a bachelor’s degree",
      "logo_url": "https://collegenroll-static.s3.us-west-1.amazonaws.com/public_media/snhu.png",
      "provider_id": "snhu-linkout",
      "revenue": 0,
      "location": {
          "city": "",
          "state": "",
          "zip_code": "",
          "distance": ""
      },
      "offer_level": "COLLEGE_LEVEL",
      "degrees": [
          "Bachelor",
          "Master",
          "Doctorate / Specialist"
      ],
      "headline": "Well-rounded programs blending theory and practice for real-world success",
      "click_url": "https://snhu.collegenroll.com/search/1/?q=snhuOmc2",
      "start_date": "Upcoming class on 28th October 2024",
      "campus_name": "Online Program",
      "campus_type": "Online",
      "popular_program": "<h4>Popular Programs</h4><ul><li>Business & Management</li><li>Psychology & Counselling</li></ul>",
      "university_redirect_url": "https://collegenroll.com/schools/snhu/",
      "program_flow_description": "<li>Choose flexible online degrees with no fixed class times.</li>\n<li>Enjoy low tuition rates, financial aid options</li>\n<li>Join 170,000+ students online, connect with peers, and access career support from enrollment to graduation.</li>",
      "short_description": "<li>Flexible degrees with no fixed class timing</li>\n<li>Low tuition, no application fees for undergraduates</li>\n<li>Receive individual support</li>",
      "programs": [],
      "ce_offer_id": "c2b5ade4-ec3f-4883-9137-60a8212e1992"
  },
  {
    "college_id": "national-university",
    "college_name": "National University",
    "is_active": true,
    "college_description": "Nationa; University emphasizes balancing academic theory, research, and hands-on training, giving you the tools to do your job ethically and to the best of your abilities. With 8 start dates per year, convenient 8-week courses with no set login* times, and flexible options for furthering your education",
    "logo_url": "https://collegenroll.com/wp-content/themes/collegenroll/assets/dedicated-lander/national/v1/images/national-logo.svg",
    "offer_level": "COLLEGE_LEVEL",
    "provider_id": "collegenroll",
    "location": {
        "city": "",
        "state": "",
        "zip_code": "",
        "distance": ""
    },
    "degrees": [
        "Bachelor",
        "Master",
        "Doctorate / Specialist"
    ],
    "headline": "Grow With Holistic Education Designed for All-Round Development",
    "click_url": "https://leads-inst494-client.phonexa.com/lynx/click?offer_id=22&aff_id=1",
    "start_date": "Classes Starting Every Month",
    "campus_name": "Online Program",
    "campus_type": "Online",
    "program_flow": {
        "headline": "Supporting students with personal attention and flexible programs for more than 130 years",
        "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
        "college_description": "<li>Flexible program options from a Christian worldview</li><li>Convenient 8-week courses with no set log-in times (some exclusions apply)</li><li>No increase in tuition rates in 9 years</li>",
        "additional_information": null
    },
    "popular_program": "<h4>Featured Programs</h4><ul><li>Psychology & Counselling</li><li>Business & Management</li><li>Nursing</li></ul>",
    "university_redirect_url": "https://collegenroll.com/schools/national-university/",
    "program_flow_description": "<li>One of the largest nonprofit universities in the U.S.</li><li>A legacy of 50 years in student-focused learning.</li><li>Dedicated 1:1 support for academic, professional, and financial concerns.</li><li>Comprehensive 4- and 8-week courses.</li>",
    "programs": [],
    "ce_offer_id": "29011658-eed9-4310-8c57-7edab8791f7g",
    "revenue": 0,
    "program_name": "GRADUATE CERTIFICATE IN MARKETING",
    "category": "all"
  },
  ]
  return harcodedOffers;
} 

function changeRankingForArcher(selectedDegree,selectedCategory,campaignName,orders){
  
  if(selectedDegree === "associate" && selectedCategory === "healthcare" && campaignName === "ce_archer_associates_healthcare"){
    orders["south-university"] = 2;
    orders["liberty-university"] = -1;
    orders["post-university1"] = 3;
  }

  if(selectedDegree === "bachelors" && selectedCategory === "healthcare" && (campaignName === "ce_archer_bacherlors_healthcare" || campaignName === "ce_archer_bachelors_healthcare")){
    orders["regent-university"] = -1;
    orders["south-university"] = 2;
    orders["liberty-university"] = -1;
    orders["post-university1"] = 4;
  }

  if(selectedDegree === "bachelors" && selectedCategory === "nursing" && campaignName === "ce_archer_bachelors_nursing"){
    orders["south-university"] = 2;
    orders["liberty-university"] = -1;
    orders["post-university1"] = 3;
  }

  if(selectedDegree === "masters" && selectedCategory === "nursing" && campaignName === "ce_archer_masters_nursing"){
    
    orders["national-university"] = -1;
    orders["liberty-university"] = -1;
    orders["post-university1"] = 3;
  }

  // orders["snhu"] = -1;
}

const getLowerCaseParams = () => {
	let lowerCaseParams = new Map();
	let urlParams = new URLSearchParams(window.location.search);
	for (const [key, value] of urlParams) {
		lowerCaseParams.set(key.toLowerCase(), value.toLowerCase());
	}
	return lowerCaseParams;
};

function changeRankingForABTest(orders) {
	const lowerCaseParams = getLowerCaseParams();
	if (lowerCaseParams.get("tmpl") === "c") {
		orders["liberty-university"] = 1;
		orders["snhu"] = 2;
	}
}

export function getMergedRankedOffers(data,selectedDegree = "all",selectedCategory = "all") {


  const orders = {
    "snhu":1,
    "keiser-university":-1,
    "south-university":4,
    "post-university":-1,
    "regent-university":-1,
    "liberty-university":2,
    "university-of-arizona-global-campus":-1,
    "fisher-college":-1,
    "everglades":8,
    "education-dynamics":-1,
    // harcoded university id
    
    "post-university1":6,
    "keiser-university1":-1,
    "snhu1":-1,
    "national-university":-1
  };


  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const lowerCaseUrlParams = new Map();
  urlParams.forEach((value,key) => lowerCaseUrlParams.set(key.toLowerCase(),value.toLowerCase()));
  
  if(urlParams.get("utm_source") === "adhere"){
    orders["snhu"]=-1;
  }

  if(urlParams.get("utm_source") === "Clicks.net" || urlParams.get("utm_source") === "clicks.net"){
    orders["regent-university"] = -1;
  }

  if(urlParams.get("snhu") === "true"){
    orders["snhu"]=-1;
  }


  if(["archereducation","archer education","archer-education"].includes(lowerCaseUrlParams.get("utm_source"))){
    changeRankingForArcher(selectedDegree,selectedCategory,lowerCaseUrlParams.get("utm_campaign"),orders);
  }

//   changeRankingForABTest(orders);

  const updatedData = data;
  const hardCodeOffers = getHardCodeOffers();
  
  updatedData.offers.directlinkoutads = [...updatedData.offers.directlinkoutads, ...hardCodeOffers];


  if(!updatedData?.offers) {
    throw new Error(`Error on Fetch Data: No offers coming from API`);
  }

  const keys = Object.keys(updatedData.offers);
  const values = Object.values(updatedData.offers);

  let offers = [];
  let eddyAggregator = {};
  values.forEach((element, index) => {
    element.forEach((university) => {
      let newObj = {...university, type: keys[index], order: orders[university.college_id]};
      if (university?.college_id === "education-dynamics") {
        eddyAggregator = newObj;
        return;
      }
      offers.push(newObj);
    });
  });
  offers.sort((a, b) => a.order - b.order);
  offers.push(eddyAggregator);
  offers = offers.filter((offers) => offers?.order !== -1);
  return offers;
}

export function modifyMetaDescription(content) {
  document.querySelector("meta[name='description']").setAttribute("content", content);
  document.querySelector("meta[property='og:description']").setAttribute("content", content);
}

export function getDegreeCategoryValue(degree,category){
  // url is pathname, value is what we will pass to the URL.
  const allDegreeMapping = [{url:"all",value:"All"},{url:"associate",value:"Associates"},{url:"bachelors",value:"Bachelors"},{url:"masters",value:"Masters"},{url:"doctorate",value:"Doctorate"},{url:"certificate-diploma",value:"Certificate"}];
  const allCategoryMapping =[
      {url:"all",value:"All"},
      {url:"business",value:"Business"},
      {url:"technology",value:"Computers"},
      {url:"criminal-justice",value:"Criminal_Justice"},
      {url:"education",value:"Education"},
      {url:"healthcare",value:"Healthcare"},
      {url:"liberal-arts",value:"Liberal_Arts"},
      {url:"nursing",value:"Nursing"},
      {url:"psychology",value:"Psychology"},
      {url:"religious",value:"Religious_Studies"}
  ]
  let degreeValue = "All",categoryValue="All";
  if(degree){ 
      allDegreeMapping.forEach((degreeObj) => {
          if(degreeObj.url === degree){
              degreeValue = degreeObj.value;
          }
      })
  }
  if(category){
      allCategoryMapping.forEach((categoryObj) => {
          if(categoryObj.url === category){
              categoryValue = categoryObj.value;
          }
      })
  }

  return [degreeValue,categoryValue];
}


export function redirectOnNewWindow(newURL,isUtmGoogleOrBing = false) {
  const width = window.screen.availWidth;
  const height = window.screen.availHeight;

  let pathname = window.location.pathname;
  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1); // Remove trailing slash
  }

  const leaveBehindPageURL = window.location.protocol + "//"+ window.location.host  + "/degree-programs/more-results";
  
  
//   if(isUtmGoogleOrBing){
//     window.open(newURL, "_blank");
//   }else{
    // window.open(newURL, "_blank", `width=${width},height=${height}, left=0,top=0,fullscreen=yes`);
    window.open(newURL, "_blank");
    window.location.href = leaveBehindPageURL;
//   }
}